import React from 'react';
import style from './style.module.scss';
import {Label as ProductLabel, renderLabelTooltip} from '../Label';
import {Typography} from 'components/Typography';
import {IProductSnippet, TProductLabel} from 'shared/types/productSnippet.types';
import {useGrowingDiscountGtag} from 'modules/product-card/analytics/gtag/hooks/useGrowingDiscountGtag';

type TGrowingDiscountLabelProps = TProductLabel & Pick<IProductSnippet, 'id'>;

export const GrowingDiscountLabel = (props: TGrowingDiscountLabelProps) => {
    const {code, title, id, url, tooltip} = props;

    const {handleShieldClick} = useGrowingDiscountGtag();

    return (
        <ProductLabel className={style.main} key={code} id={id} url={url} tooltip={renderLabelTooltip(tooltip)}>
            <Typography variant={'label-10-r'} onClick={handleShieldClick}>
                {title}
            </Typography>
        </ProductLabel>
    );
};
